// https://github.com/BrooonS/timezz

import timezz from 'timezz';

const el = '.js-countdown'

if (document.querySelector(el)) {
  const data_date = document.querySelector(el).getAttribute('data-date')

  console.log(data_date)

  timezz(document.querySelector(el), {
    date: new Date(data_date)
  })
}
